import { mapActions, mapGetters, mapState } from "vuex";
import staticColors from "@/model/colors";
import { ORDER_TYPE } from "@/utilities/enums";
import _ from "lodash";
const AppInit = {
  install(Vue) {
    Vue.mixin({
      computed: {
        ...mapGetters('locationStore', ["myTheme", "getCategories"]),
        ...mapState('locationStore', ['locations', 'business',"selectedLocation", "currentCurrency"]),
        ...mapState('cartStore', ["postcode"]),
        locationMenuItems() {
          const itemFound = this.getCategories ? this.getCategories.find(item => item.location_id == this.selectedLocation.id) : [];
          // filter categories by orer type required for deliverect
          return itemFound ? itemFound.categories.filter(cat => cat.category_availibility ? cat.category_availibility.includes(this.newCart.orderType) : cat) : []
        }
      },
      data() {
        return {
          staticColor: staticColors,
        };
      },
      methods: {
        ...mapActions('locationStore', ["fetchLocationsByPostCode", "fetchTheme", 'storeSelectedLocation']),
        isLocationEmpty() {
          return _.isEmpty(this.selectedLocation);
        },
        refreshLocationData() {
          return new Promise((resolve) => {
            //**** check if the cart is not expired */
            if (this.newCart.orderType == ORDER_TYPE.Delivery.id) {
              if (this.postcode) {
                //**** get location by postcode */
                this.fetchLocationsByPostCode(this.postcode)
                  .then((response) => {
                    this.storeSelectedLocation(response.data.data.find(
                      (x) => x.id == this.selectedLocation.id
                    ))
                    resolve(true);
                  })
                  .catch((e) => {
                    this.captureException(e);
                    this.fetchTheme().then(() => {
                      resolve(true);
                    }).catch((e) => { this.captureException(e); });
                  });
              }
            } else {
              this.fetchTheme().then(() => {
                resolve(true);
              }).catch((e) => { this.captureException(e); resolve(false) });
            }
          });
        },
      },

    });
  }
};
export default AppInit;
